/**
 * @description Действие установки пути "откуда".
 * @type {string}
 */
export const SET_FROM_ROUTE_NAME = 'SET_FROM_ROUTE_NAME';

/**
 * @description Действие удаления пути "откуда".
 * @type {string}
 */
export const REMOVE_FROM_ROUTE_NAME = 'REMOVE_FROM_ROUTE_NAME';
